function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefreshFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 16c0 6.065-4.935 11-11 11S5 22.065 5 16 9.935 5 16 5c3.092 0 5.975 1.284 8.055 3.53L21.586 11H28V4.586l-2.53 2.53A12.913 12.913 0 0016 3C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13h-2z",
    fill: props.color
  }));
}

export default SvgIconRefreshFilled;